export default "__VITE_ASSET__DUF3mYMM__"